import MasterAmpEnvelope from './MasterAmpEnvelope.js';
import OutputNode from './OutputNode.js';
import AmpEnvelope from './AmpEnvelope.js';
import Tone from 'tone';

export default superclass => class extends superclass  {
    onChangePolyphony(polyphony) {
        let voices = this.oscillatorNodes[0].voices;
        if (polyphony === voices.length) {
            return;
        }
        if (polyphony > voices.length) {
            for (let i=voices.length; i < polyphony; i++) {
                this.outputNodeX.newVoice();
                this.outputNodeY.newVoice();
            }
        } else {
            for (let i=polyphony; i < voices.length; i++) {
                this.outputNodeX.removeVoice();
                this.outputNodeY.removeVoice();
            }
        }
        this.refreshAmpEnvelopes();
    }

    refreshAmpEnvelopes() {
        this.ampEnvelope.ampEnvelopes = this.ampEnvelopes;
        this.ampEnvelope.refresh();
    }

    setupOutputs() {
        let sequencerEngine = this.sequencerEngine;
        let mixSession = this.mixSession;

        this.outputNodeX = new OutputNode(
            'X',
            -2,
            this,
            0,
            sequencerEngine,
            mixSession,
            this.context);

        this.outputNodeY = new OutputNode(
            'Y',
            -3,
            this,
            1,
            sequencerEngine,
            mixSession,
            this.context);

        this.outputCrossFade = new Tone.CrossFade(0.5);

        this.ampEnvelope = new MasterAmpEnvelope(sequencerEngine, mixSession, this.context, this.ampEnvelopes, this);
        this.ampEnvelope.name = "Amp Envelope";

        for (let osc of this.oscillatorNodes) {
            osc.ampEnvelope.name = "Envelope " + osc.name;
        }
    }

    forSlot(number) {
        let X = this.outputNodeX;
        let Y = this.outputNodeY;
        let envs = [];
        for (let osc in X.outputs) {
            if (!X.outputs[osc].ampEnvelopes[number]) {
                X.newVoice();
            }
            envs = [... envs, X.outputs[osc].ampEnvelopes[number]];
        }
        for (let osc in Y.outputs) {
            if (!Y.outputs[osc].ampEnvelopes[number]) {
                Y.newVoice();
            }
            envs = [... envs, Y.outputs[osc].ampEnvelopes[number]];
        }
        return envs;
    }

    get ampEnvelopes() {
        let X = this.outputNodeX;
        let Y = this.outputNodeY;
        let envs = [];
        for (let osc in X.outputs) {
            envs = [... envs, ... X.outputs[osc].ampEnvelopes];
        }
        for (let osc in Y.outputs) {
            envs = [... envs, ... Y.outputs[osc].ampEnvelopes];
        }
        return envs;
    }

    disposeOutputs() {
        this.outputNodeX.dispose();
        this.outputNodeY.dispose();
        this.outputCrossFade.dispose();

        this.outputNodeX = undefined;
        this.outputNodeY = undefined;
        this.outputCrossFade = undefined;
    }
}
